import React from 'react';
import Loadable from 'react-loadable';

import Spinner from '@stubhub/react-spinner';

const EntityPillBar = Loadable({
  loader: () => import('../react-entity-pill-bar'),
  loading: Spinner,
});

export default function PillBarLazyLoaded(props) {
  return <EntityPillBar {...props} />;
}
